import { gql } from 'graphql-request'

export const ListContractDetailsForSeasonGql = gql`
  query listContractDetailsForSeason($stationRecordNumber: String!) {
    listContractDetailsForSeason(request: { stationRecordNumber: $stationRecordNumber }) {
      contractName
      purchaseAccountRecordNumber
      outstanding
      contracted
    }
  }
`
